import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import loginlogo from "../../Assets/Logo/logo.png";
import "./index.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { loginuser } from "../../redux/slice/LoginSlice";
import { setAuthUser } from "../../redux/slice/AuthSlice";
import { StatusCode } from "../../services/helper";
import ButtonLoader from "../../components/Common/ButtonLoader";
import ValidationSchema from "../../components/Common/ValidationSchema";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { permissions } from "../../utils/helperFunction";
import { adminRoles, distributorRoles } from "../../utils/constants";

const Login = () => {
  const { status } = useSelector((state) => state.LOGIN);
  const initialValues = {
    email: "",
    password: "",
  };
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { values, errors, handleBlur, handleChange, touched, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: ValidationSchema.login,
      onSubmit: async (values, action) => {
        // Convert email to lowercase
        const lowercaseEmail = values.email.toLowerCase();
        const response = await dispatch(
          loginuser({ ...values, email: lowercaseEmail })
        );
        const result = response?.payload;
        if (result?.status === 200) {
          function hasPermission(array1, array2) {
            return array2.some((item) => array1.includes(item));
          }
          const isAllowed = hasPermission(
            Object.values(permissions),
            result?.data?.permissions ?? []
          );
          if (isAllowed) {
            dispatch(setAuthUser(response.payload?.data));
            if (adminRoles.includes(result?.data?.role)) {
              navigate("/");
            } else if (distributorRoles.includes(result?.data?.role)) {
              navigate("/distributor");
            }
            action.resetForm();
          }
        }
      },
    });

  return (
    <div className="container">
      <div className="row align-items-center full-dynamic-height">
        <div className="col-md-8 mx-auto py-3">
          <div className="loginWrapper  card p-4">
            <figure className="authfigure">
              <img src={loginlogo} alt="loginlogo" />
            </figure>
            <h4 className="authheading">LOGIN FORM</h4>
            <Form
              onSubmit={handleSubmit}
              className="d-flex flex-column row-gap-3"
            >
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter email"
                />
                {errors.email && touched.email && (
                  <p className="text-danger mt-1 mb-0">{errors.email} </p>
                )}
              </Form.Group>
              <Form.Group controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <div className="d-flex align-items-center">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Password"
                  />
                  {/* Toggle button to show/hide password */}
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <AiOutlineEyeInvisible />
                    ) : (
                      <AiOutlineEye />
                    )}
                  </button>
                </div>
                {errors.password && touched.password && (
                  <p className="text-danger mt-1 mb-0">{errors.password} </p>
                )}
                <NavLink
                  to="/forgot-password"
                  className="float-end mt-2"
                  style={{
                    fontSize: "14px",
                    color: "var(--bs-body-color)",
                  }}
                >
                  Forgot password?
                </NavLink>
              </Form.Group>
              <div>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={status === StatusCode.LOADING}
                >
                  {status === StatusCode.LOADING ? <ButtonLoader /> : "Submit"}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
